export default {
  API_ERROR: "Вибачте, щось пішло не так. Спробуйте ще раз.",
  FORM_ERROR: "Вибачте, але вам потрібно написати більше, щоб поділитися своєю думкою."
}
